import { find, get } from 'lodash';
import { formatDate } from './dateUtils';
import { formatIFTAmount } from './numberUtils';
import { formatIFTAccountDetails } from './accountUtils';
import { fxRatesType, WHO_PAYS_TYPE_RECIPIENT } from '../config';
import { getDebitOrCreditAmount, getPaymentFeesTitle } from './paymentsUtils';

export const getIFTPaymentDetails = (content, paymentDetails) => {
	const {
		typeLabel,
		fromLabel,
		createdByLabel,
		createdOnLabel,
		toLabel,
		amountLabel,
		refLabel,
		feesLabel,
		international,
		debitAmountLabel,
		submissionDateLabel,
		settlementDateLabel,
		exchangeRateLabel,
		indicativeExchangeRateLabel,
		bookedRate,
		authorisedBy,
	} = content;
	const {
		from_account,
		submission_date,
		to_account,
		creator_name,
		reference,
		debtor_currency,
		creditor_currency,
		value_date,
		created_timestamp,
		exchangeRate = '-',
		chargeAmount,
		indicative_fx,
		payment_amount = [],
		charging_model,
		deal_reference = '',
		final_approval,
		approvers,
	} = paymentDetails;

	const creditorAmount = getDebitOrCreditAmount(payment_amount, creditor_currency);
	const debitorAmount = getDebitOrCreditAmount(payment_amount, debtor_currency);
	const isPreBookedRate = get(indicative_fx, 'type', '') === fxRatesType.PRE_BOOKED_RATE;

	const getAmountBeingSent = (creditorAmount = '0', currency, chargeAmount = '0') => {
		const amount = Number(creditorAmount);
		const charge = Number(chargeAmount);
		const amountBeingSent = charging_model === WHO_PAYS_TYPE_RECIPIENT ? amount - charge : creditorAmount;

		return formatIFTAmount(String(amountBeingSent), currency);
	};

	const iftPaymentDetails = [
		{
			headerText: typeLabel,
			cellText: international,
		},
		{
			headerText: fromLabel,
			cellText: formatIFTAccountDetails(from_account.name, from_account.account_number),
		},
		{
			headerText: toLabel,
			cellText: formatIFTAccountDetails(to_account.name, to_account.iban || to_account.account_number),
		},
		{
			headerText: debitAmountLabel,
			cellText: debitorAmount ? formatIFTAmount(debitorAmount.value, debitorAmount.currency) : '-',
		},
		{
			headerText: feesLabel,
			cellText: chargeAmount
				? getPaymentFeesTitle(formatIFTAmount(chargeAmount.value, chargeAmount.currency), charging_model)
				: '-',
		},
		{
			headerText: submissionDateLabel,
			cellText: formatDate(submission_date),
		},
		{
			headerText: exchangeRateLabel,
			cellText: final_approval && !isPreBookedRate && exchangeRate,
		},
		{
			headerText: indicativeExchangeRateLabel,
			cellText: !final_approval && !isPreBookedRate && exchangeRate,
		},
		{
			headerText: bookedRate,
			cellText: isPreBookedRate && `${get(indicative_fx, 'rate', '')} (${deal_reference})`,
		},
		{
			headerText: amountLabel,
			cellText: creditorAmount
				? getAmountBeingSent(creditorAmount.value, creditorAmount.currency, get(chargeAmount, 'value', 0))
				: '-',
		},
		{
			headerText: settlementDateLabel,
			cellText: formatDate(value_date),
		},
		{
			headerText: refLabel,
			cellText: reference,
		},
		{
			headerText: createdByLabel,
			cellText: creator_name,
		},
		{
			headerText: createdOnLabel,
			cellText: formatDate(created_timestamp),
		},
		{
			headerText: authorisedBy,
			cellText: get(find(approvers, { status: 'VERIFIED' }), 'approver', ''),
		},
	];

	return iftPaymentDetails.filter((paymentDetails) => paymentDetails.cellText);
};
